import CurrentI18n from '@common/utils/CurrentI18n';
import { translations } from './formatDateToDays.i18n';
export var formatDateToDays = function (date) {
    var _a = CurrentI18n.getInstance().global, t = _a.t, locale = _a.locale;
    var lang = locale.value;
    var diff = Date.now() - date; // разница в миллисекундах
    if (diff < 1000) { // меньше 1 секунды
        return t(translations[lang].just_now);
    }
    var sec = Math.floor(diff / 1000); // преобразовать разницу в секунды
    if (sec < 60) {
        return sec + t(translations[lang].seconds_ago);
    }
    var min = Math.floor(diff / 60000); // преобразовать разницу в минуты
    if (min < 60) {
        return min + t(translations[lang].minutes_ago);
    }
    var days = Number((diff / 24 / 60 / 60000).toFixed(2)); // преобразовать разницу в дни
    if (days < 0.7) {
        return "".concat(t(translations[lang].today), " ").concat(date.getHours().toString().padStart(2, '0'), ":").concat(date.getMinutes().toString().padStart(2, '0'));
    }
    if (days < 2) {
        return "".concat(t(translations[lang].yesterday), " ").concat(date.getHours().toString().padStart(2, '0'), ":").concat(date.getMinutes().toString().padStart(2, '0'));
    }
    // отформатировать дату
    // добавить ведущие нули к единственной цифре дню/месяцу/часам/минутам
    var d = date;
    d = [
        '0' + d.getDate(),
        '0' + (d.getMonth() + 1),
        '' + d.getFullYear(),
        '0' + d.getHours(),
        '0' + d.getMinutes()
    ].map(function (component) { return component.slice(-2); }); // взять последние 2 цифры из каждой компоненты
    // соединить компоненты в дату
    return d.slice(0, 3).join('.') + ' ' + d.slice(3).join(':');
};
